export default __webpack_public_path__ + "static/media/Services-3.35b05e28.jpg";